export function FormatDecimals(number?: string | number): string {
  if (!number) {
    return ''
  }

  const formatted = typeof number === 'number' ? Math.round(number).toString() : number

  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
